import { useState } from 'react'

export interface FallingRollConfig {
  plateBottom: number      // Позиция тарелки от низа экрана
  rollStackHeight: number  // Высота ролла в стеке (для последующих роллов)
  startSize: number        // Начальный размер ролла
  endSize: number          // Конечный размер ролла
}

export const defaultFallingRollConfig: FallingRollConfig = {
  plateBottom: 30,
  rollStackHeight: 61,  // Высота шага в башне
  startSize: 78,        // Размер в палочках
  endSize: 62,          // 80% от startSize (уменьшение на 20%)
}

interface FallingRollEditorProps {
  config: FallingRollConfig
  onChange: (config: FallingRollConfig) => void
}

export default function FallingRollEditor({ config, onChange }: FallingRollEditorProps) {
  const [isOpen, setIsOpen] = useState(false)

  const update = (key: keyof FallingRollConfig, value: number) => {
    onChange({ ...config, [key]: value })
  }

  if (!isOpen) {
    return (
      <button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-[320px] right-2 z-50 bg-green-600 text-white px-2 py-1 rounded text-xs"
      >
        🎯 Roll
      </button>
    )
  }

  return (
    <div className="fixed bottom-[320px] right-2 z-50 bg-black/90 text-white p-3 rounded-lg text-xs w-[200px]">
      <div className="flex justify-between items-center mb-2">
        <span className="font-bold">🎯 Roll Landing</span>
        <button onClick={() => setIsOpen(false)} className="text-red-400">✕</button>
      </div>
      
      <div className="space-y-2">
        <div>
          <label className="block text-gray-400">plateBottom (тарелка от низа):</label>
          <div className="flex items-center gap-2">
            <input
              type="range"
              min="0"
              max="300"
              value={config.plateBottom}
              onChange={(e) => update('plateBottom', Number(e.target.value))}
              className="flex-1"
            />
            <input
              type="number"
              min="0"
              max="300"
              value={config.plateBottom}
              onChange={(e) => update('plateBottom', Number(e.target.value))}
              className="w-14 bg-gray-700 text-white px-1 py-0.5 rounded text-center"
            />
          </div>
        </div>
        
        <div>
          <label className="block text-gray-400">rollStackHeight (шаг башни):</label>
          <div className="flex items-center gap-2">
            <input
              type="range"
              min="10"
              max="100"
              value={config.rollStackHeight}
              onChange={(e) => update('rollStackHeight', Number(e.target.value))}
              className="flex-1"
            />
            <input
              type="number"
              min="10"
              max="100"
              value={config.rollStackHeight}
              onChange={(e) => update('rollStackHeight', Number(e.target.value))}
              className="w-14 bg-gray-700 text-white px-1 py-0.5 rounded text-center"
            />
          </div>
        </div>
        
        <div>
          <label className="block text-gray-400">startSize (в палочках):</label>
          <div className="flex items-center gap-2">
            <input
              type="range"
              min="40"
              max="150"
              value={config.startSize}
              onChange={(e) => update('startSize', Number(e.target.value))}
              className="flex-1"
            />
            <input
              type="number"
              min="40"
              max="150"
              value={config.startSize}
              onChange={(e) => update('startSize', Number(e.target.value))}
              className="w-14 bg-gray-700 text-white px-1 py-0.5 rounded text-center"
            />
          </div>
        </div>
        
        <div>
          <label className="block text-gray-400">endSize (на тарелке):</label>
          <div className="flex items-center gap-2">
            <input
              type="range"
              min="40"
              max="150"
              value={config.endSize}
              onChange={(e) => update('endSize', Number(e.target.value))}
              className="flex-1"
            />
            <input
              type="number"
              min="40"
              max="150"
              value={config.endSize}
              onChange={(e) => update('endSize', Number(e.target.value))}
              className="w-14 bg-gray-700 text-white px-1 py-0.5 rounded text-center"
            />
          </div>
        </div>
      </div>
      
      <div className="mt-3 p-2 bg-gray-800 rounded text-[10px] break-all">
        {JSON.stringify(config)}
      </div>
    </div>
  )
}

